<template>
  <div>
    <!-- NewsFeed -->
    <div class="mdc-layout-grid demo-grid section-privacy-security">
      <div class="mdc-layout-grid__inner">
        <div
          class="mdc-layout-grid__cell grid-cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
        >
          <!-- CARD CONTENT -->
          <div class="card-content pane-content p-5">
            <h6 class="mdc-typography--headline6 text-color">
              Noutăți de la prieteni
            </h6>
            <p class="mdc-typography--headline5 text-color font-weight-bold">
              De acum vezi doar ce au mai postat prietenii tăi, fără reclame sau
              postări de la companii.
            </p>
            <picture class="img-center position-relative h-100">
              <source
                srcset="/img/newsfeed/card-posts.png"
                media="(prefers-color-scheme: dark)"
                loading="lazy"
              />
              <source
                srcset="/img/newsfeed/card-posts.png"
                media="(prefers-color-scheme: light), (prefers-color-scheme: no-preference)"
                loading="lazy"
              />
              <img
                src="/img/newsfeed/card-posts.png"
                id="screenshot"
                loading="lazy"
              />
            </picture>
            <figure class="image-feature1-item1" role="img"></figure>
          </div>
          <!-- END CARD CONTENT -->
        </div>
        <div
          class="mdc-layout-grid__cell grid-cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
        >
          <!-- CARD CONTENT -->
          <div class="card-content pane-content p-5">
            <h6 class="mdc-typography--headline6 text-color">
              Noutăți de la startup-uri
            </h6>
            <p class="mdc-typography--headline5 text-color font-weight-bold">
              Nu ratezi nimic din parcursul lor către succes
            </p>
            <picture class="img-center img-fluid position-relative">
              <source
                srcset="/img/newsfeed/card-posts.png"
                media="(prefers-color-scheme: dark)"
                loading="lazy"
              />
              <source
                srcset="/img/newsfeed/card-posts.png"
                media="(prefers-color-scheme: light), (prefers-color-scheme: no-preference)"
                loading="lazy"
              />
              <img
                src="/img/newsfeed/card-posts.png"
                id="screenshot"
                loading="lazy"
              />
            </picture>
            <figure class="image-newsfeed-item2" role="img"></figure>
          </div>
          <!-- END CARD CONTENT -->
        </div>
        <!-- END ROW 1 -->
        <!-- ROW 2 -->
        <div
          class="mdc-layout-grid__cell grid-cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
        >
          <!-- CARD CONTENT -->
          <div class="card-content pane-content p-5">
            <h6 class="mdc-typography--headline6 text-color">
              Fiți la curent cu ce se întâmplă în spatele poveștilor de succes.
            </h6>
            <p class="mdc-typography--headline5 text-color font-weight-bold">
              Descoperiți toată munca desfășurată între anunțurile importante și
              poveștile de succes.
            </p>
            <figure class="image-feature1-item1" role="img"></figure>
          </div>
          <!-- END CARD CONTENT -->
        </div>
        <div
          class="mdc-layout-grid__cell grid-cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
        >
          <!-- CARD CONTENT -->
          <div class="card-content pane-content p-5">
            <h6 class="mdc-typography--headline6 text-color">
              Învățați de la ceilalți.
            </h6>
            <p class="mdc-typography--headline5 text-color font-weight-bold">
              Utilizați învățămintele sau progresele altora pentru a vă accelera
              propria productivitate. Colaborați într-o comunitate pentru a face
              schimb de idei și a rezolva probleme în jumătate din timp.
            </p>
            <figure class="image-feature1-item1" role="img"></figure>
          </div>
          <!-- END CARD CONTENT -->
        </div>
        <!-- END ROW 2-->
        <div
          class="mdc-layout-grid__cell grid-cell mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
        >
          <!-- CARD CONTENT -->
          <div class="card-content pane-content p-5">
            <h6 class="mdc-typography--headline6 text-color">
              Collections
            </h6>
            <p class="mdc-typography--headline5 text-color font-weight-bold">
              Build lists of local startups and share them with your friends.
            </p>
            <picture class="img-center position-relative h-100">
              <source
                srcset="/img/privacy/2fa.png"
                media="(prefers-color-scheme: dark)"
                loading="lazy"
              />
              <source
                srcset="/img/privacy/2fa.png"
                media="(prefers-color-scheme: light), (prefers-color-scheme: no-preference)"
                loading="lazy"
              />
              <img src="/img/privacy/2fa.png" id="screenshot" loading="lazy" />
            </picture>
          </div>
          <!-- END CARD CONTENT -->
        </div>
        <div
          class="mdc-layout-grid__cell grid-cell mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
        >
          <!-- CARD CONTENT -->
          <div class="card-content pane-content p-5">
            <h6 class="mdc-typography--headline6 text-color">
              Învățați de la ceilalți.
            </h6>
            <p class="mdc-typography--headline5 text-color font-weight-bold">
              Utilizați învățămintele sau progresele altora pentru a vă accelera
              propria productivitate. Colaborați într-o comunitate pentru a face
              schimb de idei și a rezolva probleme în jumătate din timp.
            </p>
            <figure class="image-feature1-item1" role="img"></figure>
          </div>
          <!-- END CARD CONTENT -->
        </div>
        <div
          class="mdc-layout-grid__cell grid-cell mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
        >
          <!-- CARD CONTENT -->
          <div class="card-content pane-content p-5">
            <h6 class="mdc-typography--headline6 text-color">
              Învățați de la ceilalți.
            </h6>
            <p class="mdc-typography--headline5 text-color font-weight-bold">
              Utilizați învățămintele sau progresele altora pentru a vă accelera
              propria productivitate. Colaborați într-o comunitate pentru a face
              schimb de idei și a rezolva probleme în jumătate din timp.
            </p>
            <figure class="image-feature1-item1" role="img"></figure>
          </div>
          <!-- END CARD CONTENT -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewsFeed'
}
</script>

<style></style>
